import config from '@/Constants';
import { createContext } from '@/utils/react-utils';
import React from 'react';
import { useQuery } from 'react-query';

import { ItemWithSections } from '../interfaces';
import { useInteractions } from './useInteractions';
import { useLocation } from 'react-router-dom';

export type EventItemShowContext = {
  item: ItemWithSections | undefined;
  refetch: () => void;
  isLoading?: boolean;
};

const [Context, useEventItemShow] = createContext<EventItemShowContext>({
  name: 'EventItemShowContext',
});

const EventItemShowProvider: React.FC = ({ children }) => {
  const { selectedItemId } = useInteractions();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  const { data, isLoading, refetch } = useQuery<ItemWithSections | undefined>(
    `${config.ANSWERS_URL}?item_id=${selectedItemId}${token ? `&token=${token}` : ''}`,
    {
      enabled: !!selectedItemId,
      refetchOnWindowFocus: false,
    },
  );

  return (
    <Context
      value={{
        refetch,
        item: data,
        isLoading,
      }}
    >
      {children}
    </Context>
  );
};

export { useEventItemShow, EventItemShowProvider };
